import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import { idioma } from './config.js'
import VueMask from 'v-mask';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


import './plugins/bootstrap-vue'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true // add this line

library.add(faUserSecret)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueClipboard);

Vue.use(VueMask);





let messages = require('./translations/' + idioma + '.js')
Vue.use(VueI18n)
const i18n = new VueI18n({
	locale: idioma, // set locale
	silentFallbackWarn: true, //pra não estourar no console erros quando não achar uma palavra num idioma, mas achar no outro
	messages
})


Vue.config.productionTip = false

window.vueRoot = new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app')
